<template>
  <el-drawer
    title="导出结果"
    :visible.sync="drawerVisible"
    direction="rtl"
    :wrapperClosable="true"
    :modal-append-to-body="false"
    size="70%"
    @close="handleClose">
    <p class="hint">数据处理成功后，导出记录及下载入口会保留7天，请及时下载</p>
    <div>
      <el-table v-loading="loading" :data="tableData" row-key="id" style="width:100%;">
        <el-table-column label="导出时间" prop="createTime" />
        <el-table-column label="查询条件" width="300px">
          <template slot-scope="{ row }">
            <p v-for="(item, index) in row.condition" :key="index">{{item}}</p>
          </template>
        </el-table-column>
        <el-table-column label="数据处理状态">
          <template slot-scope="{ row }">
            <span>{{ getStatusText(row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <template>
              <el-button v-if="row.status === 3" type="text" @click="downloadUrl(row)">下载</el-button>
              <span v-else>--</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div style="position: fixed; bottom: 0;"> -->
        <el-pagination
          style="padding: 16px"
          class="custom-pagination"
          :style="{ textAlign: 'right' }"
          background
          :currentPage="params.pageNum"
          :page-size="params.pageSize"
          :page-sizes="pageSizes"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :total="total"
        ></el-pagination>
      <!-- </div> -->
    </div>
  </el-drawer>
</template>
<script setup>
import { getDownloadUrl, exportRecordList } from '@/api/export'
import { ref, watch } from 'vue'

const DOWNLOAD_STATUS_OPTIONS = [
  {
    value: 0,
    label: '新建',
  },
  {
    value: 1,
    label: '生成中',
  },
  {
    value: 2,
    label: '失败',
  },
  {
    value: 3,
    label: '成功',
  },
]

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})

const total = ref(0)
const params = ref({
  pageNum: 1,
  pageSize: 10,
})
const pageSizes = [10, 20, 30, 50]
const drawerVisible = ref(false)
const loading = ref(false)
const tableData = ref([])
watch(() => props.visible, (newValue) => {
  drawerVisible.value = newValue
  newValue && getTableData()
})

async function downloadUrl(row) {
  const { data } = await getDownloadUrl({
    objectName: row.objectName,
  })
  if (data) {
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = data
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

const emit = defineEmits(['updateVisible'])
function handleClose() {
  params.value.pageNum = 1
  params.value.pageSize = 10
  emit('updateVisible', false)
}

function getStatusText(status) {
  for (const item of DOWNLOAD_STATUS_OPTIONS) {
    if (item.value === status) {
      return item.label
    }
  }
  return '--'
}

async function getTableData() {
  loading.value = true
  const { data } = await exportRecordList({
    ...params.value,
  }).finally(() => { loading.value = false })
  total.value = data.totalNum || 0
  tableData.value = data.items || []
}

function handleSizeChange(size) {
  params.value.pageNum = 1
  params.value.pageSize = size
  getTableData()
}

function handleCurrentChange(pageNum) {
  params.value.pageNum = pageNum
  getTableData()
}

</script>
<style lang="scss" scoped>
  .hint {
    margin-left: 16px;
    font-size: 14px;
    color: red;
    margin-bottom: 10px;
  }
  .custom-pagination {
    padding: 16px;
    ::v-deep .el-pagination__sizes{
      .el-select {
        width: 100px !important;
        .el-input {
          width: 100px !important;
          margin: 0 6px;
        }
      }
    }
  }
</style>
